import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';

import { TranslatePipe } from '@recruitee/i18n';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
} from '@recruitee/user-interface';

import { Destroyable } from '../../../common';
import { Offer } from '../types';

type DialogData = {
  duplicateOffer: Offer;
};

@Component({
  selector: 'rti-gfea-duplicate-posting-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gfea-duplicate-posting-dialog.component.html',
  styleUrls: ['./gfea-duplicate-posting-dialog.component.less'],
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    TranslatePipe,
  ],
})
@Destroyable()
export class GfeaDuplicatePostingDialogComponent implements DialogComponentI<DialogData, boolean> {
  public dialogData: DialogData;

  constructor(
    public dialog: DialogRef,
    private router: Router,
    private cdRef: ChangeDetectorRef,
  ) {}

  public setDialogData(data: DialogData): void {
    this.dialogData = data;
    this.cdRef.detectChanges();
  }

  public openDuplicateOffer(): void {
    window.open(`/#/offers/${this.dialogData.duplicateOffer.slug}/promote/job_boards`, '_blank');
    this.dialog.close();
  }

  public close(): void {
    this.dialog.close();
  }
}
